export default {
  welcome: {
    title: 'مرحباً بك في مساحة عمل شركتك',
    subtitle: 'كل ما تحتاجه للتوظيف على Tabbio موجود هنا.',
    features: {
      companyPage: {
        title: 'صفحة الشركة',
        body: 'أنشئ صفحة شركتك العامة وانشرها مع الوظائف المفتوحة خلال دقائق.',
      },
      applications: {
        title: 'طلبات التوظيف',
        body: 'كل طلبات التوظيف وترشيحات مجموعة المواهب تصل إلى صندوق وارد واحد.',
      },
      agent: {
        title: 'وكيل التوظيف الخاص بك',
        body: 'تحدث معه لصياغة الوظائف وتحسين صفحتك وإدارة المرشحين.',
      },
    },
    primaryCta: 'افتح صفحة الشركة',
    skipCta: 'ليس الآن',
    close: 'إغلاق',
  },
  chat: {
    title: 'المحادثات',
    newChat: '+ جديد',
    emptyState: 'ابدأ محادثة مع مساعد التوظيف الذكي',
    inputPlaceholder: 'أرسل رسالة إلى Tabbio...',
    untitledThread: 'محادثة بدون عنوان',
    deleteThreadTitle: 'حذف المحادثة؟',
    deleteThreadMessage: 'هل تريد حذف «{{title}}»؟ لا يمكن التراجع عن هذا.',
    deleteThreadConfirm: 'حذف',
    deleteThreadMenuLabel: 'حذف {{title}}',
    deleteThreadSuccess: 'تم حذف المحادثة',
    deleteThreadFailed: 'تعذر حذف المحادثة',
    deleteThreadFailedMessage: 'تمت استعادة المحادثة. يرجى المحاولة مرة أخرى.',
    clearAllHistoryAction: 'مسح جميع المحادثات',
    clearAllHistoryTitle: 'مسح جميع المحادثات؟',
    clearAllHistoryMessage: 'سيتم حذف جميع محادثاتك بشكل دائم. لا يمكن التراجع عن هذا.',
    clearAllHistoryConfirm: 'مسح الكل',
    clearAllHistoryProgress: 'جارٍ مسح المحادثات…',
    clearAllHistorySuccess: 'تم مسح جميع المحادثات',
    clearAllHistoryPartial: 'تعذر حذف بعض المحادثات',
    clearAllHistoryFailed: 'تعذر مسح المحادثات',

    // مقدمات المحادثة السياقية لشاشات صاحب العمل (لوحة المحتوى على الويب).
    routeIntro: {
      applications: {
        m1: 'أنت في صندوق طلبات التوظيف. يمكنني مساعدتك في العثور على المرشحين أو تلخيص مسار التوظيف أو نقل المتقدمين إلى المرحلة التالية.',
        m2: 'هذه كل الطلبات وتسجيلات شبكة المواهب لشركتك. اطلب مني التصفية أو التلخيص أو مقارنة المرشحين.',
        m3: 'يمكنني الاطلاع على مسار التوظيف هنا. اسألني عمّن تقدّم مؤخرًا أو أي وظيفة تحتاج إلى اهتمام.',
        chips: {
          latest: 'أحدث الطلبات',
          pipeline: 'ملخص مسار التوظيف',
          role: 'الوظيفة الأكثر تقديمًا',
        },
      },
      companyPage: {
        m1: 'أنت تحرّر صفحة شركتك. يمكنني مساعدتك في صقل النبذة أو تخطيط الأقسام أو صياغة إعلان وظيفة.',
        m2: 'هذه واجهتك العامة للتوظيف. اسألني عمّا يمكن تحسينه قبل مشاركتها.',
        m3: 'يمكنني مساعدتك في إكمال صفحة الشركة: النبذة والأسئلة الشائعة والوظائف والمشاركة.',
        chips: {
          improve: 'ما الذي نحسّنه؟',
          bio: 'صقل النبذة',
          jobs: 'صياغة إعلان وظيفة',
        },
      },
    },
  },

  candidates: {
    title: 'المرشحون',
    subtitle: 'تصفح وأدِر قائمة المرشحين',
    detail: 'ملف المرشح',
    shortlist: 'القائمة المختصرة',
  },

  jobs: {
    title: 'إعلانات الوظائف',
    create: 'إنشاء وظيفة',
    applicants: 'المتقدمون',
  },

  company: {
    title: 'ملف الشركة',
  },

  // مسار إنشاء وتعديل الوظائف بأربع خطوات
  jobFlow: {
    steps: {
      basics: {
        title: 'أساسيات الوظيفة',
        subtitle: 'المسمى والفريق ومكان العمل. يمكنك تعديل كل شيء لاحقًا.',
      },
      requirements: {
        title: 'متطلبات التوظيف',
        subtitle: 'صِف الوظيفة واذكر ما يجب أن يمتلكه المرشح المناسب.',
      },
      applications: {
        title: 'طلبات التقديم',
        subtitle: 'الراتب ومتطلبات المرشح والأسئلة التي يجيب عنها المتقدمون.',
      },
      review: {
        title: 'المراجعة والنشر',
        subtitle: 'تحقق من التفاصيل واختر أماكن ظهور الوظيفة ثم انشرها أو احفظها.',
      },
    },
    edit: {
      title: 'تعديل الوظيفة',
      loading: 'جارٍ تحميل هذه الوظيفة…',
      notFoundTitle: 'الوظيفة غير موجودة',
      notFoundBody: 'هذه الوظيفة لم تعد متاحة في مساحة العمل النشطة.',
    },
    aiBadge: 'مسودة بالذكاء الاصطناعي — راجع كل حقل',
    fields: {
      summary: 'ملخص الوظيفة',
      responsibilities: 'المسؤوليات',
      requirements: 'المؤهلات المطلوبة',
      niceToHave: 'مؤهلات إضافية',
      benefits: 'المزايا',
      seniority: 'مستوى الخبرة',
      countryOptional: 'الدولة (اختياري)',
      cityOptional: 'المنطقة المعروضة (اختياري)',
      candidateLocation: 'موقع المرشح',
      experienceYears: 'الخبرة ذات الصلة',
      language: 'اللغة',
      workEligibility: 'أهلية العمل',
      nationality: 'الجنسية',
    },
    placeholders: {
      summary: 'ما تدور حوله الوظيفة، ومع من يعمل صاحبها، ولماذا هي مهمة. عشرون حرفًا على الأقل.',
      responsibility: 'أضف مسؤولية',
      requirement: 'أضف مؤهلًا مطلوبًا',
      niceToHave: 'أضف مؤهلًا إضافيًا',
      benefit: 'أضف ميزة',
    },
    list: {
      add: 'إضافة عنصر',
      remove: 'إزالة العنصر',
      moveUp: 'نقل لأعلى',
      moveDown: 'نقل لأسفل',
      empty: 'لم تتم إضافة شيء بعد.',
    },
    salary: {
      title: 'الراتب',
      min: 'الحد الأدنى',
      max: 'الحد الأقصى',
      minPlaceholder: 'مثال: 15000',
      maxPlaceholder: 'مثال: 25000',
      currency: 'العملة',
      period: 'الفترة',
      showOnPost: 'إظهار الراتب في إعلان الوظيفة',
      showOnPostHint: 'الرواتب المخفية تبقى ظاهرة لفريقك فقط.',
    },
    requirementsGroup: {
      title: 'متطلبات المرشح',
    },
    workforce: {
      hint: 'لا تستخدم هذا الحقل إلا عندما تفرضه حصة توطين. الجنسية خلاف ذلك صفة محمية.',
      note: 'ملاحظة السياسة / الاعتماد',
      notePlaceholder: 'أشر إلى السياسة الموثقة أو الاعتماد الذي يسمح بهذا المتطلب (عشرون حرفًا على الأقل).',
      acknowledged: 'موثق ومعتمد',
      acknowledgedHint: 'أؤكد أن هذا المتطلب يتبع إجراءً موثقًا خضع لمراجعة قانونية.',
    },
    questions: {
      defaultsTitle: 'الأسئلة الافتراضية',
      defaultsHint: 'فعّل الأسئلة القياسية وحدد طريقة إجابة المرشحين عنها.',
      customTitle: 'أسئلتك',
      customHint: 'أضف أسئلة خاصة بالوظيفة يجيب عنها المرشحون عند التقديم.',
      addQuestion: 'إضافة سؤال',
      answerType: 'نوع الإجابة',
      required: 'إلزامي',
      promptPlaceholder: 'اكتب سؤالك',
      options: 'الخيارات',
      optionPlaceholder: 'أضف خيارًا',
      duplicate: 'تكرار السؤال',
      delete: 'حذف السؤال',
      customLabel: 'السؤال {{number}}',
      types: {
        yes_no: 'نعم / لا',
        multiple_choice: 'اختيار من متعدد',
        short_answer: 'إجابة قصيرة',
        long_answer: 'إجابة مطولة',
        number: 'رقم',
      },
      defaults: {
        education: {
          prompt: 'ما أعلى مؤهل تعليمي أكملته؟',
          options: {
            highSchool: 'الثانوية العامة',
            diploma: 'دبلوم',
            bachelors: 'بكالوريوس',
            masters: 'ماجستير',
            doctorate: 'دكتوراه',
            other: 'أخرى',
          },
        },
        experienceYears: {
          prompt: 'كم عدد سنوات خبرتك ذات الصلة؟',
        },
        expectedSalary: {
          prompt: 'ما راتبك الشهري المتوقع (بالدرهم الإماراتي)؟',
        },
        availability: {
          prompt: 'متى يمكنك البدء؟',
          options: {
            immediate: 'فورًا',
            oneMonth: 'خلال شهر',
            twoMonths: 'خلال شهرين',
            threeMonths: 'خلال ثلاثة أشهر',
            moreThanThree: 'أكثر من ثلاثة أشهر',
          },
        },
      },
    },
    options: {
      seniority: {
        entry: 'مبتدئ',
        mid: 'متوسط',
        senior: 'خبير',
        lead: 'قائد فريق',
        executive: 'تنفيذي',
      },
      // نسبي حسب موقع الوظيفة: {{country}} و{{city}} و{{region}} تأتي من بيانات
      // الوظيفة نفسها، فتغطي مجموعة واحدة من النصوص كل الأسواق.
      candidateLocation: {
        any: 'أي موقع',
        in_country: 'في {{country}}',
        in_city: 'في {{city}}',
        in_region: 'في {{region}}',
        open_to_relocation: 'مستعد للانتقال إلى {{country}}',
        open_to_relocation_any: 'مستعد للانتقال',
        // تُستخدم عندما تشير القيمة المحفوظة إلى مستوى لا تملك الوظيفة بياناته،
        // فلا يظهر الحقل فارغًا وكأن الإجابة ضاعت.
        in_country_generic: 'في دولة الوظيفة',
        in_city_generic: 'في مدينة الوظيفة',
        in_region_generic: 'في منطقة الوظيفة',
      },
      experienceYears: {
        any: 'أي خبرة',
        '1_plus': 'سنة فأكثر',
        '3_plus': '3 سنوات فأكثر',
        '5_plus': '5 سنوات فأكثر',
        '7_plus': '7 سنوات فأكثر',
        '10_plus': '10 سنوات فأكثر',
      },
      language: {
        any: 'أي لغة',
        english: 'الإنجليزية',
        arabic: 'العربية',
        english_and_arabic: 'الإنجليزية والعربية معًا',
        english_or_arabic: 'الإنجليزية أو العربية',
      },
      workEligibility: {
        any: 'أي وضع',
        eligible: 'مؤهل للعمل هناك حاليًا',
        eligible_or_sponsorship: 'مؤهل أو يحتاج إلى كفالة',
        sponsorship_required: 'يتطلب كفالة',
      },
      // تُطلب فقط لدعم حصص التوطين الخليجية، وكل اختيار غير "بدون" يبقى مشروطًا
      // بملاحظة السياسة أدناه.
      nationality: {
        none: 'بدون اشتراط',
        emirati: 'إماراتي',
        saudi: 'سعودي',
        qatari: 'قطري',
        kuwaiti: 'كويتي',
        bahraini: 'بحريني',
        omani: 'عُماني',
        gcc: 'أي مواطن خليجي',
        other: 'أخرى',
      },
      period: {
        monthly: 'شهريًا',
        yearly: 'سنويًا',
      },
    },
    review: {
      edit: 'تعديل',
      basicsTitle: 'الأساسيات',
      contentTitle: 'محتوى الوظيفة',
      applicationsTitle: 'طلبات التقديم',
      untitled: 'وظيفة بدون عنوان',
      salaryNotSet: 'غير محدد',
      salaryShown: 'ظاهر في الإعلان',
      salaryHidden: 'مخفي عن الإعلان',
      noRequirements: 'مفتوحة لجميع المرشحين',
      questionsLabel: 'أسئلة التقديم',
      questionCount_zero: 'بدون أسئلة',
      questionCount_one: 'سؤال واحد',
      questionCount_two: 'سؤالان',
      questionCount_few: '{{count}} أسئلة',
      questionCount_many: '{{count}} سؤالًا',
      questionCount_other: '{{count}} سؤال',
      distributionTitle: 'أماكن ظهور هذه الوظيفة',
    },
    distribution: {
      tabbio_and_company: {
        title: 'لوحة وظائف Tabbio + صفحة شركتك',
        body: 'تُدرج في المكانين.',
        summary: 'سيجد المرشحون هذه الوظيفة في لوحة وظائف Tabbio وعلى صفحة شركتك.',
      },
      tabbio_only: {
        title: 'لوحة وظائف Tabbio فقط',
        body: 'لا تُدرج على صفحة شركتك.',
        summary: 'سيجد المرشحون هذه الوظيفة في لوحة وظائف Tabbio، ولن تظهر على صفحة شركتك.',
      },
      company_page_only: {
        title: 'صفحة شركتك فقط',
        body: 'لا تُدرج في لوحة وظائف Tabbio.',
        summary: 'سيجد المرشحون هذه الوظيفة على صفحة شركتك، ولن تظهر في لوحة وظائف Tabbio.',
      },
      hidden: {
        title: 'غير مُدرجة في أي مكان',
        body: 'يراها فريقك فقط.',
        summary: 'لا يمكن لأحد خارج فريقك رؤية هذه الوظيفة.',
      },
    },
    confidential: {
      toggle: 'إخفاء اسم شركتك',
      hint: 'يرى المرشحون الاسم أدناه بدلًا من اسم شركتك وشعارها.',
      labelField: 'الاسم الذي سيراه المرشحون',
      labelPlaceholder: 'مثال: مجموعة تجزئة رائدة في الإمارات',
      summary: 'يُستبدل اسم شركتك وشعارها بـ «{{label}}».',
      unnamedLabel: 'تسميتك العامة',
    },
    actions: {
      saveDraft: 'حفظ كمسودة',
      publish: 'نشر',
      publishing: 'جارٍ النشر…',
      saveChanges: 'حفظ التغييرات',
      saving: 'جارٍ الحفظ…',
    },
    toasts: {
      publishedTitle: 'تم نشر الوظيفة',
      publishedBody: 'وظيفتك متاحة الآن وتستقبل طلبات التقديم.',
      draftTitle: 'تم حفظ المسودة',
      draftBody: 'حُفظت هذه الوظيفة بشكل خاص. انشرها عندما تكون جاهزة.',
      savedTitle: 'تم حفظ التغييرات',
      savedBody: 'تم تحديث الوظيفة.',
      offlineTitle: 'تم إيقاف الوظيفة',
      offlineBody: 'توقف استقبال الطلبات الجديدة مع الاحتفاظ بالمتقدمين الحاليين.',
      reopenedTitle: 'أُعيد فتح الوظيفة',
      reopenedBody: 'عادت الوظيفة للعمل بنطاق النشر السابق نفسه.',
      archivedTitle: 'تمت أرشفة الوظيفة',
      deletedTitle: 'تم حذف الوظيفة',
      deletedBody: 'أُزيلت من صفحتك مع الاحتفاظ بالمتقدمين والسجل.',
    },
    errors: {
      modeRequired: 'صِف الوظيفة أو اختر النشر يدويًا.',
      briefTooShort: 'صِف الوظيفة في عشرين حرفًا على الأقل ليتمكن الذكاء الاصطناعي من صياغتها.',
      titleRequired: 'أضف مسمى الوظيفة.',
      titleLength: 'يجب أن يكون مسمى الوظيفة بين 2 و160 حرفًا.',
      countryRequired: 'اختر دولة، أو اجعل الوظيفة عن بُعد.',
      cityRequired: 'اختر مدينة للوظائف الحضورية والهجينة.',
      summaryTooShort: 'اكتب ملخصًا للوظيفة من عشرين حرفًا على الأقل.',
      responsibilitiesRequired: 'أضف مسؤولية واحدة على الأقل.',
      requirementsRequired: 'أضف مؤهلًا مطلوبًا واحدًا على الأقل.',
      salaryInvalid: 'يجب أن يكون الراتب رقمًا موجبًا.',
      salaryRange: 'يجب ألا يتجاوز الحد الأدنى للراتب الحد الأقصى.',
      questionPromptRequired: 'اكتب نص السؤال.',
      questionOptionsRequired: 'يتطلب الاختيار من متعدد خيارين مختلفين على الأقل.',
      workforceNoteRequired: 'أضف ملاحظة سياسة أو اعتماد من عشرين حرفًا على الأقل.',
      workforceAckRequired: 'أكد أن هذا المتطلب موثق ومعتمد.',
      confidentialDistribution: 'يتطلب إخفاء اسم شركتك إدراج الوظيفة في لوحة وظائف Tabbio.',
      confidentialLabelRequired: 'أضف تسمية عامة من 2 إلى 80 حرفًا.',
      generateFailed: 'تعذر إنشاء إعلان الوظيفة',
      submitFailed: 'تعذر حفظ هذه الوظيفة',
      submitFailedHint: 'يرجى المحاولة مرة أخرى. لم يُنشر شيء.',
      companyRequired: 'انتقل إلى مساحة عمل الشركة قبل نشر وظيفة.',
    },
    status: {
      draft: 'مسودة',
      live: 'منشورة',
      offline: 'متوقفة',
      archived: 'مؤرشفة',
    },
    discard: {
      title: 'تجاهل التغييرات؟',
      body: 'تحتوي هذه الوظيفة على تغييرات غير محفوظة. إذا غادرت الآن ستفقدها.',
      confirm: 'تجاهل التغييرات',
      keepEditing: 'متابعة التحرير',
    },
    lifecycle: {
      edit: 'تعديل',
      publish: 'نشر',
      takeOffline: 'إيقاف الوظيفة',
      reopen: 'إعادة فتح',
      archive: 'أرشفة',
      cancel: 'إلغاء',
      offlineConfirmTitle: 'إيقاف هذه الوظيفة؟',
      offlineConfirmBody: 'لن يتمكن المرشحون من التقديم بعد الآن، مع بقاء المتقدمين الحاليين في مسارك.',
      offlineConfirmAction: 'إيقاف الوظيفة',
      archiveConfirmTitle: 'أرشفة هذه الوظيفة؟',
      archiveConfirmBody: 'تخرج الوظائف المؤرشفة من الإدارة اليومية مع الاحتفاظ بالمتقدمين والسجل.',
      archiveConfirmAction: 'أرشفة',
      delete: 'حذف',
      deleteConfirmTitle: 'حذف هذه الوظيفة؟',
      deleteConfirmBody:
        'ستُزال من صفحتك ومن الإدارة اليومية مع الاحتفاظ بالمتقدمين والسجل.',
      deleteConfirmBodyLive:
        'هذه الوظيفة منشورة. سيتم إيقافها ثم إزالتها من صفحتك مع الاحتفاظ بالمتقدمين والسجل.',
      deleteConfirmAction: 'حذف',
      // حذف وظيفة منشورة يتم على خطوتين (إيقاف ثم أرشفة): هذه الحالة عند نجاح الأولى فقط.
      // تُعرض في نافذة حوار لا في إشعار عابر؛ النص أطول من أن يظهر كاملًا في الإشعار.
      deleteOfflinedOnlyTitle: 'تم إيقافها ولم تُحذف',
      deleteOfflinedOnlyBody:
        'هذه الوظيفة لم تعد معروضة على صفحتك ولا تقبل الطلبات، لكن تعذر حذفها. أعد المحاولة، أو أعد فتحها لإرجاعها للعمل.',
      deleteOfflinedOnlyRetry: 'أعد المحاولة',
      deleteOfflinedOnlyDismiss: 'ليس الآن',
      // تعذرت إعادة المحاولة أيضًا: الحالة نفسها والنافذة نفسها، ولا نكرر
      // السؤال حتى لا يدور المستخدم في حلقة، فيبقى خيار إعادة الفتح.
      deleteOfflinedOnlyRetryFailedBody:
        'لا تزال هذه الوظيفة خارج صفحتك ولا تقبل الطلبات، وما زال حذفها متعذرًا. أعد فتحها لإرجاعها للعمل، أو اتركها موقوفة وحاول حذفها لاحقًا.',
      deleteOfflinedOnlyReopen: 'إعادة فتح الوظيفة',
      failedTitle: 'تعذر تحديث هذه الوظيفة',
    },
  },

  // صندوق طلبات التوظيف على مستوى الشركة (المرحلة الأولى WP4)
  applications: {
    title: 'طلبات التوظيف',
    subtitle: 'كل الطلبات وتسجيلات شبكة المواهب لشركتك.',
    searchPlaceholder: 'ابحث عن المرشحين',
    countLabel_zero: 'لا توجد طلبات',
    countLabel_one: 'طلب واحد',
    countLabel_two: 'طلبان',
    countLabel_few: '{{count}} طلبات',
    countLabel_many: '{{count}} طلبًا',
    countLabel_other: '{{count}} طلب',
    filters: {
      destinationAll: 'كل الوجهات',
    },
    sort: {
      label: 'الترتيب',
      activity: 'أحدث نشاط',
      newest: 'الأحدث',
    },
    status: {
      active: 'ضمن شبكة المواهب',
    },
    destinations: {
      talentNetwork: 'انضم إلى شبكة المواهب لدينا',
    },
    empty: {
      title: 'لا توجد طلبات بعد',
      subtitle:
        'تصل الطلبات عندما يتقدم المرشحون إلى وظائفك المنشورة أو ينضمون إلى شبكة المواهب من صفحة شركتك العامة.',
      action: 'افتح صفحة الشركة',
    },
    filteredEmpty: {
      title: 'لا توجد طلبات مطابقة',
      subtitle:
        'جرّب بحثًا مختلفًا أو امسح عوامل التصفية لعرض قائمة الشركة كاملة.',
    },
    error: {
      title: 'تعذّر تحميل الطلبات',
      subtitle:
        'حاول مرة أخرى بعد قليل. لا تزال مساحة عمل شركتك بحاجة إلى الوصول إلى هذا الصندوق.',
    },
    submittedCv: 'السيرة الذاتية المقدَّمة',
    submittedCvAt: 'قُدّمت {{date}}',
    currentCvNotice: 'السيرة الذاتية الحالية',
    currentCvNoticeBody:
      'لم تُرفق سيرة ذاتية بهذا الطلب — هذه هي السيرة الذاتية الحالية للمرشح وقد تتغير في أي وقت.',
    unsavedSnapshotNoticeBody:
      'لم تُحفظ نسخة من السيرة الذاتية عند تقديم هذا الطلب — هذه هي السيرة الذاتية الحالية للمرشح وقد تكون تغيّرت منذ تقديمه.',
    cvNoSections: 'لا تحتوي هذه السيرة الذاتية على أقسام بعد.',
    submittedAgo: 'قُدّم {{time}}',
    detail: {
      talentTitle: 'تسجيل في شبكة المواهب',
      destinationLabel: 'الوجهة',
      submittedLabel: 'تاريخ التقديم',
      statusLabel: 'الحالة',
      consentTitle: 'الموافقة',
      consentBody: 'وافق هذا المرشح على أن تنظر شركتك في ترشيحه لفرص مستقبلية.',
      consentAcceptedAt: 'تمت الموافقة {{date}}',
      withdrawnNotice:
        'انسحب هذا المرشح من شبكة المواهب لديكم. يبقى تسجيله في السجل، لكن لا ينبغي التواصل معه بشأن وظائف جديدة.',
      selectPrompt: {
        title: 'اختر طلبًا',
        subtitle:
          'اختر مرشحًا من القائمة لمراجعة سيرته الذاتية المقدَّمة وإجاباته وسجله.',
      },
    },
  },
} as const;
